// import React from "react";
// import { Link, useLocation } from "react-router-dom";

// const serviceAreas = [
//   { label: "Cankaya Koltuk Yıkama", path: "/cankaya/cankaya-koltuk-yikama" },
//   { label: "Cankaya Yorgan Yıkama", path: "/cankaya/cankaya-yorgan-yikama" },
//   { label: "Cankaya Battaniye Yıkama", path: "/cankaya/cankaya-battaniye-yikama" },
//   { label: "Cankaya Kuru Temizleme", path: "/cankaya/cankaya-kuru-temizleme" },
//   { label: "Cankaya Perde Yıkama", path: "/cankaya/cankaya-perde-yikama" },
//   { label: "Cankaya Yerinde Yıkama", path: "/cankaya/cankaya-yerinde-yikama" },
//   { label: "Cankaya Yatak Yıkama", path: "/cankaya/cankaya-yatak-yikama" },
//   { label: "İncek Halı Yıkama", path: "/cankaya/incek-hali-yikama" },
//   { label: "İncek Koltuk Yıkama", path: "/cankaya/incek-koltuk-yikama" },
//   { label: "İncek Yorgan Yıkama", path: "/cankaya/incek-yorgan-yikama" },
//   { label: "İncek Perde Yıkama", path: "/cankaya/incek-perde-yikama" },

// ]
//   const CankayaServiceArea = () => {
//   const location = useLocation();

//   return (
//     <div className="text-[#003132] mt-0 w-full">
//       <h2 className="text-lg font-semibold mb-1 uppercase tracking-wide text-center">ÇANKAYA HİZMET TÜRLERİ</h2>

//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full">
//         {serviceAreas.map((area, index) => (
//           <Link
//             key={index}
//             to={area.path}
//             className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
//               location.pathname === area.path
//                 ? "bg-green-700 text-white"
//                 : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
//             }`}
//           >
//             {area.label}
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CankayaServiceArea;
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const serviceAreas = [
  { label: "Cankaya Koltuk Yıkama", path: "/cankaya/cankaya-koltuk-yikama" },
  { label: "Cankaya Yorgan Yıkama", path: "/cankaya/cankaya-yorgan-yikama" },
  { label: "Cankaya Battaniye Yıkama", path: "/cankaya/cankaya-battaniye-yikama" },
  { label: "Cankaya Kuru Temizleme", path: "/cankaya/cankaya-kuru-temizleme" },
  { label: "Cankaya Perde Yıkama", path: "/cankaya/cankaya-perde-yikama" },
  { label: "Cankaya Yerinde Yıkama", path: "/cankaya/cankaya-yerinde-yikama" },
  { label: "Cankaya Yatak Yıkama", path: "/cankaya/cankaya-yatak-yikama" },
  { label: "İncek Halı Yıkama", path: "/cankaya/incek-hali-yikama" },
  { label: "İncek Koltuk Yıkama", path: "/cankaya/incek-koltuk-yikama" },
  { label: "İncek Yorgan Yıkama", path: "/cankaya/incek-yorgan-yikama" },
  { label: "İncek Perde Yıkama", path: "/cankaya/incek-perde-yikama" },
];

const CankayaServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      {/* Başlık ve Aç/Kapa Butonu */}
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          ÇANKAYA HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {/* Açılır Grid */}
      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {serviceAreas.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default CankayaServiceArea;
